const styles = {
  detailsBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  scrollableDetailsBox: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  form: {
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  } as const,
  hidden: {
    display: 'none',
  },
  noDataPlaceHolderContainer: {
    marginX: '8px',
    marginTop: '8px',
  },
  noDataPlaceHolderText: {
    fontSize: '16px',
  }
};

export default styles;
